import type { AnySceneObjectT } from "tweenly"
import { sortObjects } from "tweenly"
import { ObjectsStateT, selectObjectById } from "../../objects.slice"

export const checkIndexesBase = (state: ObjectsStateT, parentId: string | null) => {
    const objects = Object.values(state.value)
    //if no objects then return
    if (objects.length === 0) return

    let siblings: AnySceneObjectT[]

    if (parentId) {
        const parentChildIds: string[] = selectObjectById(state, parentId).childIds
        // if not indexes for control then return
        if (parentChildIds.length === 0) return
        // find all siblings from parent.childIds
        // `state` is an Immer draft here — use the local array, never the memoized
        // selectObjects, so revoked drafts can never end up in its cache
        siblings = parentChildIds.map((id) => objects.filter((object) => object.id === id)[0])
    } else {
        siblings = objects.filter((object) => object.parentId === null)
    }

    // order siblings objects by index
    const orderedSiblings: AnySceneObjectT[] = sortObjects(siblings)

    // if their index is not equal to order, update its index
    orderedSiblings.forEach((sibling, index) => {
        if (sibling.index !== index) {
            state.value = {
                ...state.value,
                [sibling.id]: { ...state.value[sibling.id], index: index },
            }
        }
    })
}
